<template>
    <form-model title="订单调度" width="1000" ref="formModel">
        <div style="margin-bottom: 20px;" slot="topcontent">
            <RadioGroup v-if="false" @on-change="change" v-model="item.dispatchType">
                <Radio v-for="(y, index1) in selectItems" :label="y.id" :key="index1">
                    <span>{{ y.name }}</span>
                </Radio>
            </RadioGroup>
        </div>
        <p style="margin-bottom: 10px;margin-top: 20px;" slot="endcontent">调度历史记录</p>
        <diaoduHistory ref="diaoduHistory" slot="endcontent"></diaoduHistory>
        <Button slot="btn" type="primary" @click="diaodu">立即调度</Button>
    </form-model>
</template>
<script>
var flows = [];
var list=[];
import diaoduHistory from "./diaoduHistory.vue";
export default {
    components: { diaoduHistory },
    data() {
        return {
            forms: [
                {
                    title: "车牌号",
                    key: "carId",
                    key1: "carNo",
                    required: false,
                    isHand: true,
                    readonly: false,
                    clearable: true,
                    type: "selectCar",
                    span: 6,
                },
                {
                    title: "司机",
                    key4: "driverAccount",
                    key1: "driver",
                    clearable: true,
                    isHand: true,
                    required: false,
                    type: "selectUser",
                    span: 6,
                    keyword: "司机",
                },
                {
                    title: "计费方式",
                    key: "applyRuleId",
                    clearable: true,
                    type: "Select",
                    selectType:"obj",
                    selectItems: list,
                },
            ],
            item: {
                dispatchType: 1,
                ono: "",
                carNo: "",
                driverAccount: "",
                driver: "",
                driverAccountHk: "",
                driverHk: "",
                lable: "",
                nodeId: "",
                nodeName: "",
                flowId: "",
                //flowStartId: "",
                remark: "",
                applyRuleId: "",
                keyword: ""
            },
            tradeType: null,
            selectItems: [
                { id: 0, name: '直采' },
                { id: 1, name: '接驳' },
                { id: 2, name: '第三方' }
            ]
        }
    },
    methods: {

        reach(v) {

            //console.log(v);
            this.tradeType = "公务用车";
            this.item.ono = v.title;
            this.$refs.formModel.reach(this.forms, this.item);
            this.$refs.formModel.resetForm();
            this.getFlowList();
            this.$refs.diaoduHistory.open(this.item);
            this.getRuleList();
            //this.getInfo();
        },
        diaodu() {
            this.zhenghe();
            console.log(this.item);
            
            this.utils.loading(this, "加载中");
            this.axios({
                method: "post",
                url: this.axios.ipPort + "/cloud-ofc-server-web/dispatch/add",
                data: this.item,
            }).then((res) => {
                this.$Spin.hide(); //关闭加载
                if (res) {
                    // this.$refs.formModel.close();
                    this.$refs.diaoduHistory.open(this.item);
                    // this.getList();
                }
            });
        },
        getFlowList() {
            flows.length = 0;
            this.axios({
                method: "post",
                url: this.axios.ipPort + "/cloud-ofc-server-web/flowConfig/list",
                data: {},
            }).then((res) => {
                this.$Spin.hide(); //关闭加载
                this.total = res.data.data.total;
                var data = res.data.data.dataList;
                console.log(data);

                for (let i = 0; i < data.length; i++) {
                    flows.push(data[i]);
                    console.log(data[i].tag, this.tradeType);
                    if (data[i].tag.includes(this.tradeType)) {
                        this.item.flowId = data[i].id;
                        //console.log(12244455)
                    }

                }


            });
        },
        //获取计费规则
        getRuleList() {
            this.utils.loading(this, "加载中");
            this.axios({
                method: "post",
                url: this.axios.dpc + "/applyRule/list",
                data: {},
            }).then((res) => {
                this.$Spin.hide(); //关闭加载
                this.total = res.data.data.total;
                var data = res.data.data.dataList;
                var obj = {
                    1: '公里',
                    2: "小时",
                }
                list.length=0;
                for (let i = 0; i < data.length; i++) {
                    data[i].unit2 = obj[data[i].unit];
                    var obj={
                        id:data[i].id,
                        name:data[i].name
                    }
                    list.push(obj);
                }
            });
        },
        //获取调度详情
        getInfo() {
            flows.length = 0;
            this.axios({
                method: "post",
                url: this.axios.ipPort + "/cloud-ofc-server-web/dispatch/info",
                data: { ono: this.item.ono },
            }).then((res) => {
                this.$Spin.hide(); //关闭加载
                console.log(3333, res);
                var data = res.data.data;
                for (const i in this.item) {
                    //this.item[i]=data[i];
                }


            });
        },
        change(v) {
            console.log(v);
            var m = []
            if (v === 0) {
                m = [{
                    title: "司机",
                    key4: "driverAccount",
                    key1: "driver",
                    clearable: true,
                    isHand: true,
                    required: false,
                    type: "selectUser",
                    span: 6,
                    keyword: "司机",
                },
                ]

            } else if (v === 1) {
                m = [{
                    title: "大陆司机",
                    key4: "driverAccount",
                    key1: "driver",
                    clearable: true,
                    isHand: true,
                    required: false,
                    type: "selectUser",
                    span: 6,
                    keyword: "司机",
                },
                {
                    title: "香港司机",
                    key4: "driverAccountHk",
                    key1: "driverHk",
                    clearable: true,
                    isHand: true,
                    required: false,
                    type: "selectUser",
                    span: 6,
                    keyword: "司机",
                }]
            } else {
                m = [{
                    title: "司机",
                    key4: "driverAccount",
                    key1: "driver",
                    clearable: true,
                    isHand: true,
                    required: false,
                    type: "selectUser",
                    span: 6,
                    keyword: "司机",
                },]
            }
            var t = [
                {
                    title: "车牌号",
                    key: "carId",
                    key1: "carNo",
                    required: false,
                    isHand: true,
                    readonly: false,
                    clearable: true,
                    type: "selectCar",
                    span: 6,
                },
                ...m,


            ]
            this.$refs.formModel.reach(t, this.item);
        },
        //整合
        zhenghe() {
            var type = this.item.dispatchType;
            if (type === 0) {
                //直采，两个司机必须一样
                this.item.driverAccountHk = this.item.driverAccount;
                this.item.driverHk = this.item.driver;
            } else if (type === 1) {

            } else {
                this.item.driverAccountHk = this.item.driverAccount;
                this.item.driverHk = this.item.driver;
            }
        }

    }
}
</script>


// WEBPACK FOOTER //
// src/components/diaodu/diaoduNew/diaodu.vue